import { render } from "./DownloadLink.vue?vue&type=template&id=2e8cf15a&bindings={\"apiUrl\":\"props\",\"filename\":\"props\",\"isLoading\":\"data\",\"errors\":\"data\",\"download\":\"options\",\"triggerBrowserDownload\":\"options\"}"
import script from "./DownloadLink.vue?vue&type=script&lang=js"
export * from "./DownloadLink.vue?vue&type=script&lang=js"
script.render = render

export default script